export default "__VITE_ASSET__DdK415j5__"